<!--
Composant Header
Global au projet Isni

une props => le titre si besoin

-->
<template>
  <header>
    <div class="row header-wrapper light-blue darken-4">
      <BanqBack />
      <div class="container ">
        <div class="col s12">
          <div class="header-wrapper__logo-banq col s4 m4 l2">
            <span @click="reloadForm">
              <router-link to="/"
                ><img
                  src="./../../assets/images/BAnQ_logo_95.png"
                  alt="logo BanQ"
                  title="Accueil"
                  class="responsive-img"
              /></router-link>
            </span>
          </div>
          <div class="col s6 m5 l3">
            <h1 class="header__titre white-text">{{ title }}</h1>
          </div>
          <div class="col s2 m2 l2 header-wrapper__logo-isni ">
            <img
              src="./../../assets/images/Logo-ISNI.png"
              alt="logo Isni"
              title="Logo Isni"
              class="logo-isni responsive-img"
            />
          </div>
          <div
            class="header-wrapper__select-lang input-field col s2 m1 l1 push-l5"
          >
            <select
              name="langue"
              title="langue"
              v-model="langSelected"
              @change="ohHeaderChangesLang($event)"
            >
              <option value="fr" selected>Fr</option>
              <option value="en">En</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import BanqBack from "../layout/BanqBack.vue";
import { langService } from "@/services/lang.service";

export default {
  name: "Header",
  props: {
    onAppChangesLang: Boolean,
    title: String
  },
  data() {
    return {
      langSelected: "fr"
    };
  },
  components: {
    BanqBack
  },
  methods: {
    ohHeaderChangesLang(event) {
      this.langSelected = event.target.value;

      // update lang to all pages
      langService.setLang(this.langSelected);

      // spread the new lang triggers
      this.$emit('headerChangesLangTrigger');
    },
    //  chargement de la page et app force
    reloadForm() {
      this.$router.go(0);
    }
  },
  watch: {
    onAppChangesLang: function() {
      // get lang from service
      this.langSelected = langService.getLang();
    }
  }
};
</script>

<style scoped lang="scss">
.header-wrapper {
  height: 170px;
  margin-bottom: 0;
  .header-wrapper__logo-banq {
    margin-top: 6px;
  }
  .header__titre {
    font-size: 5rem;
    padding-top: 13px;
    margin: 0;
  }
  .logo-isni {
    margin-top: 15px;
  }
  .header-wrapper__logo-isni {
    margin-top: 15px;
  }
  .header-wrapper__select-lang {
    margin-top: 5px;
    select option {
      color: white;
    }
  }
}
@media (min-width: 768px) {
  .header-wrapper {
    margin-bottom: 0;
    height: 160px;

    .header__titre {
      font-size: 6rem;
    }
    .header-wrapper__logo-isni {
      /*margin-top: 15px;*/
    }
  }
}
</style>
